module.exports = __webpack_public_path__ + "img/87_15.bc43db28.png";